<div class="auth-page">
  <div class="auth-shell auth-shell--register kota-enter-seq">
    <div
      class="auth-shell__image"
      role="img"
      aria-label="Ambiente hogar"
      style="background-image: url('https://images.unsplash.com/photo-1768077710231-f3a256362553?auto=format&fit=crop&w=1200&q=80')"
    ></div>

    <div class="auth-shell__form">
      <a routerLink="/" class="auth-logo">
        <img src="assets/img/kota_logo.png" alt="KOTA" class="auth-logo__img" />
      </a>

      <!-- ── PASO 1: Formulario ── -->
      @if (step() === 'form') {
        <div class="auth-heading">
          <h1 class="auth-title">Crear Cuenta</h1>
          <p class="auth-subtitle">Únete a nuestra comunidad y descubre el confort que mereces</p>
        </div>

        @if (error()) {
          <p class="auth-error">{{ error() }}</p>
        }

        <form class="auth-form" (ngSubmit)="onSubmit()">
          <div class="auth-row">
            <div class="auth-field">
              <label class="auth-label" for="reg-first">Nombre</label>
              <div class="auth-input-wrap">
                <input id="reg-first" name="firstName" type="text" class="auth-input"
                  placeholder="Tu nombre" [(ngModel)]="firstName" autocomplete="given-name" required />
              </div>
            </div>
            <div class="auth-field">
              <label class="auth-label" for="reg-last">Apellido</label>
              <div class="auth-input-wrap">
                <input id="reg-last" name="lastName" type="text" class="auth-input"
                  placeholder="Tu apellido" [(ngModel)]="lastName" autocomplete="family-name" />
              </div>
            </div>
          </div>

          <div class="auth-field">
            <label class="auth-label" for="reg-email">Correo electrónico</label>
            <div class="auth-input-wrap">
              <input id="reg-email" name="email" type="email" class="auth-input"
                placeholder="tu@email.com" [(ngModel)]="email" autocomplete="email" required />
            </div>
          </div>

          <div class="auth-field">
            <label class="auth-label" for="reg-password">Contraseña</label>
            <div class="auth-input-wrap">
              <input id="reg-password" name="password" [type]="showPassword() ? 'text' : 'password'"
                class="auth-input" placeholder="••••••••" [(ngModel)]="password"
                autocomplete="new-password" required />
              <button type="button" class="auth-toggle-pass" (click)="togglePassword()"
                [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                @if (showPassword()) {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" />
                  </svg>
                } @else {
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                    <line x1="2" x2="22" y1="2" y2="22" />
                  </svg>
                }
              </button>
            </div>
          </div>

          <!-- Google reCAPTCHA v2 -->
          <div class="auth-field auth-recaptcha">
            <re-captcha (resolved)="onCaptchaResolved($event)"></re-captcha>
          </div>

          <label class="auth-terms">
            <input type="checkbox" class="auth-checkbox" name="acceptTerms" [(ngModel)]="acceptTerms" />
            <span class="auth-checkbox-ui" [class.is-checked]="acceptTerms">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </span>
            Acepto los términos y condiciones
          </label>

          <button type="submit" class="auth-btn auth-btn--primary" [disabled]="!acceptTerms || loading()">
            @if (loading()) { Enviando código… } @else { Enviar código de verificación }
          </button>
        </form>

        <div class="auth-divider">
          <span class="auth-divider__line"></span>
          <span class="auth-divider__text">o continúa con</span>
          <span class="auth-divider__line"></span>
        </div>

        <div class="auth-social">
          <button type="button" class="auth-btn auth-btn--social" (click)="noopSocial($event)">
            <span style="font-size:18px;font-weight:700">G</span> Google
          </button>
          <button type="button" class="auth-btn auth-btn--social" (click)="noopSocial($event)">
            <svg class="fb-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
            </svg>
            Facebook
          </button>
        </div>

        <p class="auth-switch">
          <span class="auth-switch__muted">¿Ya tienes cuenta?</span>
          <a routerLink="/login" class="auth-switch__link">Inicia sesión</a>
        </p>
      }

      <!-- ── PASO 2: Verificar código ── -->
      @if (step() === 'verify') {
        <div class="auth-heading">
          <h1 class="auth-title">Verifica tu correo</h1>
          <p class="auth-subtitle">
            Enviamos un código de 6 dígitos a<br>
            <strong>{{ email }}</strong>
          </p>
        </div>

        @if (error()) {
          <p class="auth-error">{{ error() }}</p>
        }

        <form class="auth-form" (ngSubmit)="onVerify()">
          <div class="auth-code-wrap">
            @for (digit of codeDigits(); track $index) {
              <input
                [id]="'digit-' + $index"
                type="text"
                inputmode="numeric"
                maxlength="1"
                class="auth-code-digit"
                [value]="digit"
                (input)="onDigitInput($index, $event)"
                (keydown)="onDigitKeydown($index, $event)"
                (paste)="onDigitPaste($event)"
                autocomplete="one-time-code"
              />
            }
          </div>

          <button type="submit" class="auth-btn auth-btn--primary"
            [disabled]="verificationCode().length < 6 || loading()">
            @if (loading()) { Verificando… } @else { Crear cuenta }
          </button>
        </form>

        <div class="auth-resend">
          @if (countdown() > 0) {
            <p class="auth-resend__timer">Reenviar en <strong>{{ countdownLabel }}</strong></p>
          } @else {
            <p class="auth-resend__text">
              ¿No recibiste el código?
              <button type="button" class="auth-resend__btn" (click)="resendCode()" [disabled]="loading()">
                Reenviar
              </button>
            </p>
          }
        </div>

        <button type="button" class="auth-back" (click)="goBack()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="m15 18-6-6 6-6" />
          </svg>
          Volver al formulario
        </button>
      }
    </div>
  </div>
</div>
